export const HERO_MODULE_TYPE = 'hero';
export const MAIN_CONTENT_MODULE_TYPE = 'main_content';
export const PHOTO_CAROUSE_MODULE_TYPE = 'photoCarousel';
export const CREATOR_SPOTLIGHT_TYPE = 'creator_spotlight';
